import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import SignupData from "../SignupData";
const Signup = lazy(() => import("../userTypeSelect/Signup"));
const ApprenticeSignup = lazy(
  () => import("../ApprenticeSignup/ApprenticeSignup")
);
const TradieSignup = lazy(() => import("../tradieSignup/tradieSignup"));

const SignupRoutes = () => {
  return (
    <>
      <Routes>
        <Route index path="" element={<Signup />} />
        <Route path="client" element={<SignupData />} />
        <Route path="professional" element={<TradieSignup />} />
        <Route path="apprentice" element={<ApprenticeSignup />} />
        <Route path="freeProfessional" element={<TradieSignup />} />
      </Routes>
    </>
  );
};

export default SignupRoutes;
